// Ledger State

export default {
  ledgerList: [],
  ledgerDetailList: []
}
